export default __webpack_public_path__ + "static/media/PrayersAndWritings.93f4d60a.png";